import axios from 'axios';

export class Service{
    http = null;
    baseUrl = 'https://candia-verde.ekapps.gr/api';

    constructor(){
        this.http = axios.create({
            baseURL: this.baseUrl,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    // Ingredients
    async getIngredients(){
        try {
            const response = await this.http.get('/ingredients');
            return response.data;
        } catch (error) {
            console.error('Error fetching ingredients:', error);
            return [];
        }
    }

    async addIngredient(ingredient){
        try {
            const response = await this.http.post('/ingredients', {
                code: ingredient.code,
                title: ingredient.title
            });
            return response.data;
        } catch (error) {
            console.error('Error adding ingredient:', error);
            throw error;
        }
    }

    async updateIngredient(ingredient){
        try {
            const response = await this.http.put(`/ingredients/${ingredient.id}`, {
                id: ingredient.id,
                code: ingredient.code,
                title: ingredient.title
            });
            return response.data;
        } catch (error) {
            console.error('Error updating ingredient:', error);
            throw error;
        }
    }

    async deleteIngredient(id){
        try {
            await this.http.delete(`/ingredients/${id}`);
            return true;
        } catch (error) {
            console.error('Error deleting ingredient:', error);
            return false;
        }
    }

    // Products
    async getProducts(){
        try {
            const response = await this.http.get('/products');
            return response.data;
        } catch (error) {
            console.error('Error fetching products:', error);
            return [];
        }
    }

    async addProduct(product){
        try {
            const response = await this.http.post('/products', {
                code: product.code,
                title: product.title,
                description: product.description
            });
            return response.data;
        } catch (error) {
            console.error('Error adding product:', error);
            throw error;
        }
    }

    async updateProduct(product){
        try {
            const response = await this.http.put(`/products/${product.id}`, {
                id: product.id,
                code: product.code,
                title: product.title,
                description: product.description
            });
            return response.data;
        } catch (error) {
            console.error('Error updating product:', error);
            throw error;
        }
    }

    async deleteProduct(id){
        try {
            await this.http.delete(`/products/${id}`);
            return true;
        } catch (error) {
            console.error('Error deleting product:', error);
            return false;
        }
    }

    // Recipes
    async getRecipies(){
        try {
            const response = await this.http.get('/recipes');
            return response.data;
        } catch (error) {
            console.error('Error fetching recipes:', error);
            return [];
        }
    }

    async addRecipy(recipy){
        try {
            const sanitizedIngredients = (recipy.ingredients || [])
                .filter(i => i && i.ingredientId && i.ingredientId !== '' && i.ingredientId !== '00000000-0000-0000-0000-000000000000')
                .map(i => ({
                    ingredientId: i.ingredientId,
                    qty: Number(i.qty) || 0,
                    unit: i.unit || 'gr'
                }));

            const response = await this.http.post('/recipes', {
                title: (recipy.title || '').trim() || 'Νέα Συνταγή',
                itemCode: recipy.itemCode || '',
                description: recipy.description || '',
                qty: Number(recipy.qty) || 0,
                ingredients: sanitizedIngredients
            });
            return response.data;
        } catch (error) {
            console.error('Error adding recipe:', error);
            throw error;
        }
    }

    async updateRecipy(recipy){
        try {
            const sanitizedIngredients = (recipy.ingredients || [])
                .filter(i => i && i.ingredientId && i.ingredientId !== '' && i.ingredientId !== '00000000-0000-0000-0000-000000000000')
                .map(i => ({
                    id: i.id || undefined,
                    ingredientId: i.ingredientId,
                    qty: Number(i.qty) || 0,
                    unit: i.unit || 'gr'
                }));

            const response = await this.http.put(`/recipes/${recipy.id}`, {
                id: recipy.id,
                title: (recipy.title || '').trim() || 'Συνταγή Χωρίς Τίτλο',
                itemCode: recipy.itemCode || '',
                description: recipy.description || '',
                qty: Number(recipy.qty) || 0,
                ingredients: sanitizedIngredients
            });
            return response.data;
        } catch (error) {
            console.error('Error updating recipe:', error);
            throw error;
        }
    }

    async deleteRecipy(id){
        try {
            await this.http.delete(`/recipes/${id}`);
            return true;
        } catch (error) {
            console.error('Error deleting recipe:', error);
            return false;
        }
    }

    // Commands
    async getCommands(){
        try {
            const response = await this.http.get('/commands');
            return response.data;
        } catch (error) {
            console.error('Error fetching commands:', error);
            return [];
        }
    }

    async addCommand(command){
        try {
            const response = await this.http.post('/commands', {
                title: command.title,
                description: command.description,
                recipeId: command.recipyId || command.recipeId,
                qty: command.qty,
                status: command.status || 'Αναμονή'
            });
            return response.data;
        } catch (error) {
            console.error('Error adding command:', error);
            throw error;
        }
    }

    async saveCommand(command){
        try {
            const response = await this.http.put(`/commands/${command.id}`, {
                id: command.id,
                title: command.title,
                description: command.description,
                recipeId: command.recipyId || command.recipeId,
                qty: command.qty,
                status: command.status
            });
            return response.data;
        } catch (error) {
            console.error('Error saving command:', error);
            throw error;
        }
    }

    async deleteCommand(id){
        try {
            await this.http.delete(`/commands/${id}`);
            return true;
        } catch (error) {
            console.error('Error deleting command:', error);
            return false;
        }
    }

    async recordProduction(command){
        try {
            // const response = await this.http.post('/productions', {
            //     commandId: command.id,
            //     qtys: command.qtys,
            //     weight: command.weight
            // });
            // return response.data;
            console.log('Recording production for command:', command);
        } catch (error) {
            console.error('Error recording production:', error);
            throw error;
        }
    }
}